import { ReactComponent as GleapLogo } from "../../Assets/PoweredByGleapLogo.svg";
import { ReactComponent as Bolt } from "../../Assets/bolt-solid.svg";
import Communicator from "../../Helper/Communicator";
import { activateOnKey } from "../../Helper/a11y";
import { useConfigStore } from "../../Stores/Config";
import { useSessionStore } from "../../Stores/Session";
import "./WidgetPoweredBy.scss";

/**
 * Where the badge leads: gleap.ai with the widget's UTM tags, the "Powered by
 * Gleap" campaign and the project's public SDK key as `ref`, so a signup can be
 * traced back to the workspace whose widget showed the badge. (The help center
 * footer's badge carries the same campaign and ref.)
 */
const poweredByUrl = (apiUrl: string, sdkKey: string) => {
  const params = new URLSearchParams({
    utm_source: "widget",
    utm_medium: "referral",
    utm_campaign: "powered_by",
    utm_content: apiUrl,
  });
  if (sdkKey) {
    params.set("ref", sdkKey);
  }
  return `https://www.gleap.ai/?${params.toString()}`;
};

function WidgetPoweredBy() {
  const config = useConfigStore((state) => state.config);
  const sessionStore = useSessionStore((state) => state);
  // The server decides: a plan without "remove branding" always gets false.
  const showGleapLogo =
    typeof config.hideBranding === "undefined" || !config.hideBranding;

  const openGleap = () => {
    if (showGleapLogo) {
      Communicator.openURL(
        poweredByUrl(sessionStore.apiUrl, sessionStore.sdkKey)
      );
    }
  };

  return (
    <div
      className={`powered-by ${!showGleapLogo && "powered-by--hidden"}`}
      role="button"
      tabIndex={0}
      aria-label="Powered by Gleap"
      onClick={openGleap}
      onKeyDown={activateOnKey(openGleap)}
    >
      {showGleapLogo && (
        <div className="powered-by--inner" dir="ltr">
          <Bolt className="bolt" />
          <span>Powered by</span>
          <GleapLogo className="logo" />
        </div>
      )}
    </div>
  );
}

export default WidgetPoweredBy;
